function CreateVariableModalController(stateService) {
    const ctrl = this;
  
    ctrl.$onInit = () => {
        ctrl.variables = ctrl.resolve.variables;
        ctrl.defaultVariableType = 'user';
        ctrl.duplicateName = false;
    };
  
    ctrl.submit = () => {
        ctrl.variable.type = ctrl.defaultVariableType;
        ctrl.close({ $value: ctrl.variable });
    };
  
    ctrl.cancel = () => {
      ctrl.dismiss({  });
    };

    ctrl.checkName = () => {
      if (!ctrl.variable.name) return;
      ctrl.duplicateName = ctrl.variables
        .find(variable => variable.name === ctrl.variable.name) ? true : false;
    };
  }

  angular
    .module('pis-tool.module')
    .controller('CreateVariableModalController', CreateVariableModalController);
  